import { getSessionStorage } from './stage';
export function appPostMessage(msg) {
	const msgVal = JSON.stringify(msg);
	console.log('msgVal', msgVal);
	var u = navigator.userAgent;
	console.log('ceshi666666', u);
	var isiOS = !!u.match(/\Mac OS X/);
	// var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
	var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
	if (isiOS) {
		window.webkit.messageHandlers.FUNTOY.postMessage(msgVal);
	} else if (isAndroid) {
		if (getSessionStorage('isNewAndroid') == 1) {
			luaGet1('js://liuzhipeng?json=' + msgVal);
		} else {
			luaGet('liuzhipeng://json=' + msgVal);
		}
	} else if (u.match(/iPad/i) == 'ipad') {
		window.webkit.messageHandlers.FUNTOY.postMessage(msgVal);
	}
}

function luaGet(URL) {
	console.log('luaGet', URL);
	var temp = document.createElement('form');
	temp.action = URL;
	temp.method = 'get';
	temp.style.display = 'none';

	document.body.appendChild(temp);
	temp.submit();

	return temp;
}
function luaGet1(URL) {
	document.location = URL;
}
